import React from 'react'
import { AiOutlineComment } from 'react-icons/ai';



/**
 * A component that renders a comment icon.
 * #comments
 * @param {function} onClick - The function to call when the icon is clicked.
 * @param {number} fontSize - The size of the icon. Default is 25.
 */
const CommentIcon = ({onClick, fontSize=25 }) => {
  return (
    <button className="round-red-button" style={{backgroundColor:"green", marginLeft:"10px", width:"110px", borderRadius:"30px"}} onClick={onClick} type="button">
    <AiOutlineComment 
    fontSize={fontSize}
    color={"white"} />
    <h3 style={{color:"white"}}>SALVA</h3>
</button>
  )
}

export default CommentIcon
